import React from 'react';
import { makeStyles } from '@material-ui/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import dateFormat from 'utils/date';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  }
}));

function getActionName(actionName) {
  return actionName.replace('mutation.', '');
}

function renderIp(ip) {
  return ip ? `- ${ip}` : '';
}

function renderName(auditLog) {
  return auditLog.userName ? auditLog.userName : auditLog.userEmail;
}
export default function AlignItemsList({ auditLogs }) {
  const classes = useStyles();

  return (
    <List className={classes.root}>
      {auditLogs.map((auditLog, index) => {
        return (
          <div key={auditLog.uId}>
            <ListItem alignItems="flex-start">
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes.inline}
                      color="textPrimary"
                    >
                      {renderName(auditLog)}
                    </Typography>
                    {` `}
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes.inline}
                      color="primary"
                    >
                      {getActionName(auditLog.actionName)}
                    </Typography>
                    <Typography
                      component="span"
                      variant="caption"
                      className={classes.inline}
                      color="textPrimary"
                    >
                      {` - ${dateFormat.timeAgo(auditLog.logTime)} ${renderIp(
                        auditLog.originIp
                      )}`}
                    </Typography>
                  </React.Fragment>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="caption"
                      className={classes.inline}
                      color="textPrimary"
                    >
                      {`${
                        auditLog.actionMetadata === '{}'
                          ? ''
                          : auditLog.actionMetadata
                      }`}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
            {index < auditLogs.length - 1 && (
              <Divider variant="fullWidth" component="li" />
            )}
          </div>
        );
      })}
    </List>
  );
}
